export default __webpack_public_path__ + "static/media/goshen108.55c218e2.jpg";